/**
 * Floating back-to-top / back-to-bottom buttons (was scrolltop.js).
 */
import { fadeIn, fadeOut } from '../lib/dom';

function button(id, cls, icon, bottom, hidden) {
    const a = document.createElement('a');
    a.id = id;
    a.href = '#';
    a.className = `shadow border btn btn-light btn-xl ${cls}`;
    a.setAttribute('role', 'button');
    a.innerHTML = `<i class="fa ${icon}"></i>`;
    Object.assign(a.style, {
        position: 'fixed',
        bottom,
        right: '2px',
        width: '40px',
        paddingTop: '0.75rem',
        paddingBottom: '0.75rem',
    });
    if (hidden) a.style.display = 'none';
    return a;
}

export function initScrollTop() {
    const footer = document.querySelector('footer');
    if (!footer || document.getElementById('back-to-top')) return;
    const toBottom = button('back-to-bottom', 'back-to-bottom', 'fa-chevron-down', '8px', false);
    const toTop = button('back-to-top', 'back-to-top', 'fa-chevron-up', '52px', true);
    footer.append(toBottom, toTop);

    const update = () => {
        const scrollTop = window.scrollY;
        const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
        if (scrollTop > 50) fadeIn(toTop);
        else fadeOut(toTop);
        if (maxScroll - scrollTop > 50) fadeIn(toBottom);
        else fadeOut(toBottom);
    };
    window.addEventListener('scroll', update, { passive: true });

    toTop.addEventListener('click', (e) => {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
    });
    toBottom.addEventListener('click', (e) => {
        e.preventDefault();
        window.scrollTo({ top: document.documentElement.scrollHeight - window.innerHeight, behavior: 'smooth' });
    });
}
